import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const doublePieValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'x2', type: 'string', required: true },
    { field: 'y2', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'double-pie-data-size-recommendation',
      validator: data => data.length <= 15,
      message: 'Double pie chart works best with fewer than 15 data points for better readability',
      suggestion: 'Consider using other chart types for larger datasets',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'double-pie-minimum-data',
      validator: data => data.length >= 2,
      message: 'Double pie chart requires at least 2 data points to show distribution',
      suggestion: 'Provide at least 2 data points for meaningful comparison',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
